import { memo } from 'react'
import cn from 'classnames'

import { LUNYA_AVATAR_SRC } from './config'
import type { LunyaAvatarProps } from './types'

import styles from './LunyaAvatar.module.scss'

/** Круглая мини-Луня — голова маскота в карточках-репликах (LunyaCard, LunyaLine). */
export const LunyaAvatar = memo(function LunyaAvatar(props: LunyaAvatarProps) {
  const { size, hasGlow = false } = props

  return (
    <div
      className={cn(styles.root, hasGlow && styles.hasGlow)}
      style={{ width: size, height: size }}
    >
      <img className={styles.image} src={LUNYA_AVATAR_SRC} alt='' />
    </div>
  )
})
